import { Button } from "antd";
import { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class AgentsListSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "agent_name",
        label: "Agent Name",
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.EMPLOYEE_STATUS,
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex" style={{ zIndex: 1 }}>
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <div className="d-flex align-items-start justify-content-start">
          <div className="header_box d-flex flex-col align-items-center">
            <div className="row"></div>
            <div className="d-flex flex-row-reverse">
              <Button
                type="primary"
                className="btn btn-primary"
                htmlType="button"
                onClick={(...args) => this.props.openApplicationModal(...args)}
              >
                Add Agent
              </Button>
            </div>
          </div>
        </div>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(AgentsListSearch);
